const config = {
  baseUrl: 'https://api.quote-me.dev.itcentar.rs/api',
  auth: true,
  production: true,
  dateFormat: 'DD.MM.YYYY',
  dateTimeFormat: 'DD.MM.YYYY HH:mm',
};

export default config;
